<div>
  <input class="standardTextBox filterInput" placeholder="Filter list" [(ngModel)]="listFilter" (keyup)="filterList()"/>
</div>
<table class="addressGrid reportTable">
  <thead>
    <tr>
      <td class="tableCell headerCell">Attention</td>
      <td class="tableCell headerCell">Address</td>
      <td class="tableCell headerCell">City</td>
      <td class="tableCell headerCell">State</td>
    </tr>
  </thead>
  @if (filteredAddresses().length > 0) {
    @for (address of filteredAddresses(); track address; let rowIndex = $index) {
      <tr [class.selectedRow]="rowIndex === selectedRowId" class="selectableRow" (click)="selectRow(rowIndex, address)">
        <td class="tableCell">{{ address.attentionLine }}</td>
        <td class="tableCell">{{ address.addressLine1 }}</td>
        <td class="tableCell">{{ address.cityName }}</td>
        <td class="tableCell">{{ address.stateCode }}</td>
      </tr>
    }
  }
  @if (filteredAddresses().length === 0) {
    <tr>
      <td class="tableCell centeredCell" colspan="4">No addresses found</td>
    </tr>
  }
</table>
